import { DEFAULT_TAB_CONFIG } from "../../../../../../stores/use-page-store";
import { DefaultActiveElements } from "../../../settings/features/pages/defaults";

const DEFAULT_DATA = {
  config: {
    showTabs: false,
    type: "pages",
    columns: 3,
    pagination: "infinite",
    cardBorderRadius: 3,
    labelsColor: { accent: "#000000", text: "#FFFFFF" },
    spaceColor: { accent: "#000000", text: "#FFFFFF" },
    activeElements: DefaultActiveElements,
    size: 12,
    tabs: {
      t38kX5BODZ: { ...DEFAULT_TAB_CONFIG },
    },
  },
  tabs: [
    {
      id: "t38kX5BODZ",
      name: "",
      position: 0,
    },
  ],
};

export const PAGES_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "card",
    },
  },
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "mini_card",
    },
  },
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "list",
    },
  },
];

export const buildTemplate = (variant, borderRadius) => ({
  ...DEFAULT_DATA,
  config: {
    ...DEFAULT_DATA.config,
    variant,
    cardBorderRadius: borderRadius,
  },
});
